import React, { useEffect, useRef, useState } from 'react';
import { Table,Row,Col, Button, Divider,Avatar,Typography, Spin, message, Modal, Form, Upload, Input, Select, Image, Space, Popconfirm, Tooltip, Card, Empty, Pagination, Carousel } from 'antd';
import APIUtils from '../../api/APIUtils';
import { CheckCircleFilled,UploadOutlined,PlayCircleOutlined, SettingOutlined, CloseCircleOutlined, EllipsisOutlined, FacebookFilled, InstagramOutlined, PauseCircleOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import moment from 'moment';
import constants from '../../constants/constants';
import WebLinks from '../../api/WebLinks';
import { useContext } from 'react';
import { CommonContext, CurrencyContext } from '../../Context';
import SocialConfigureDefault from '../../assets/Social-configure-default.png'


const { Paragraph } = Typography;
const { Search } = Input;

const SocialMediaConfigure = () => {
    const currencyContext=useContext(CurrencyContext);
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;
    const [Loading,setLoading]=useState(false);
    const [loadingAsset,setLoadingAsset]=useState(true);
    const [NewModalOpen,setNewModalOpen]=useState(false);
    const [updateRecord,setUpdateRecord]=useState(false);
    const [jobId,setJobId]=useState(null);
    const [updateImage,setUpdateImage]=useState(null);
    const [updateVideo,setUpdateVideo]=useState(null);
    const [total,setTotal]=useState(0);
    const [data,setData]=useState([]);
    const [occupations,setOccupations]=useState([]);
    const [form] = Form.useForm();
    const [visibleVideo, setVisibleVideo] = useState(false);
    const [urlTypeValue, setUrlTypeValue] = useState('CareersSiteJobURL');
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: constants.pageSize,
      total: 0,
    });
    const [currentPage,setCurrentPage]=useState(1);
    const [videoUrl, setVideoUrl] = useState('');
    const [jobURl,setJobUrl]=useState('');
    const [jobURlParam,setJobUrlParam]=useState('');
    const [pageSize,setPageSize]=useState(constants.defaultSocialConfigurePagesize);
    const [selectModalVisible, setSelectModalVisible] = useState(false);
    const [selectModalType, setSelectModalType] = useState('');
    const [selectImageItems, setSelectImageItems] = useState([]);
    const [selectVideoItems, setSelectVideoItems] = useState([]);
    const [selectTextItems, setSelectTextItems] = useState([]);
    const [selectedVideoUrl] = useState('');
    const [selectedText, setSelectedText] = useState('');
    const [selectedImage,setSelectedImage]=useState(null);
    const [selectedVideo,setSelectedVideo]=useState(null);
    const [countArrayOptions,setCountArrayOptions]=useState([]);
    const [jobslist,setJobs]=useState([]);
    const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
    const [sorter, setSorter] = useState({
      field: 'Occupation',
      order: 'ascend',
    });
    const [finalURL,setFinalURL]=useState('');
    const [searchedValue,setSearchedvalue]=useState("");
    const [isSelfService, setIsSelfService] = useState(sessionStorage.getItem('isSelfService') );
    const isSelfServiceUser = isSelfService === true || isSelfService === "true";
    const [careerSiteDomain,setCareerSiteDomain]=useState(null);
    const [siteUrlLinks,setSiteUrlLinks]=useState([])

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        sorter: true
      },
      {
        title: 'Occupation',
        dataIndex: 'occupation',
        key: 'occupation',
        sorter: true
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: true
      },
      {
        title: 'Job',
        dataIndex: 'jobTitle',
        key: 'jobTitle',
        sorter: true
      },
      {
        title: 'Promo Image',
        dataIndex: 'socialPostImageURL',
        key: 'promoimage',
          render: (text) => text?<Image src={text} alt="Promo" className='!w-36' />:"",
        align:'center'
      },
      {
        title: 'Promo Video',
        dataIndex: 'socialPostVideoURL',
        key: 'socialPostVideoURL',
        render: (text) =>text?<Tooltip title="Play Video"><Button type='link' onClick={() => handlePlay(text)} icon={<PlayCircleOutlined className='!text-3xl text-teal-500' />}/></Tooltip>:null,
        align:'center'
      },
      {
        title: 'Promo Text',
        dataIndex: 'socialPostText',
        key: 'promotext',
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => (
          <Space>
            <Button type="primary" size='small' onClick={() => handleUpdate(record.id)}>
              Update
            </Button>
            <Popconfirm
              title="Are you sure to delete this record?"
              onConfirm={ () => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
                <Button type="primary" danger size='small'>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        ),
      },
    ];
    const urlTypeOptions = isSelfService === true || isSelfService === "true"
      ? careerSiteDomain == null
        ? [
            {
              key: 1,
              value: 'ApplyGatewayJobURL',
              label: "Apply Gateway Job URL",
            },
          ]
        : [
          {
            key: 1,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
        ]
      : [
          {
            key: 1,
            value: 'CareersSiteJobURL',
            label: "Careers Site Job URL",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
          {
            key: 3,
            value: 'LandingPageURL',
            label: "Landing Page URL",
          },
          ...(careerSiteDomain == null ? [] : [{
            key: 4,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          }]),
        ];

    const handleUpdate = (id) => {
      loadOccupations();
      const editRecord = data.find((row)=> row.id===id);
      setUpdateRecord(editRecord);
      setNewModalOpen(true);
      setUpdateImage(editRecord.socialPostImageURL);
      setUpdateVideo(editRecord.socialPostVideoURL);
      // setImageurl(editRecord.socialPostImageURL);
      setUrlTypeValue(editRecord.socialPostURLType);
      setJobUrlParam(editRecord?.socialPostURLParams||'')
      getJobURL(editRecord.occupationId,editRecord?.jobId);
      redirectToJobURL(editRecord?.socialPostURLParamsReplace,editRecord?.socialPostURLParams,"t");
      form.setFieldsValue({
        promoText:editRecord.socialPostText,
        //spendperad:editRecord.spendPerAd,
        //job:editRecord.jobId,
        urlTypes: editRecord.socialPostURLType,
        urltrackingCode: editRecord?.socialPostURLParams||"",
        urltrackingCodeReplace: editRecord?.socialPostURLParamsReplace||"",
        landingPageUrl: editRecord?.socialPostLandingPage||[]
      })
    };

    const getSiteUrls = async() =>{
      setLoading(true);
      const response = await APIUtils.apiCall('GET',WebLinks.GetSiteUrlLinks+buyerId,null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          setSiteUrlLinks(response?.resultObj?.data);
      }else{
          setSiteUrlLinks([]);
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };

  // Create an array of numbers 
  const generateOptions = () => {
    let countArray=[];
    for (let i = 80; i <= 500; i=i+20) {
      countArray.push(
       {
        value:i,
        label:i
       }
      );
    }
    setCountArrayOptions(countArray);
  };

    const handleDelete = async(id) => {
          setLoading(true);
          const response = await APIUtils.apiCall('DELETE',WebLinks.DeleteSocialConfig+id,null,true,false);
          if(!response.isCatch && response.resultObj.statusCode==="2000"){
             getData(searchedValue,currentPage,pageSize);
             getOccupations();
             message.success(response?.resultObj?.message || "Deleted record successfully");
          }else{
              message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
          }
          setLoading(false);
    };
    const getData = async(searchValue,currentPage,pageSize)=>{
        setLoading(true);
        let desc = sorter.order === 'descend' ? "true" : "false";
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialMediaConfigureLiveJobs+"buyerId="+buyerId+"&limit="+pageSize+"&pageNo="+currentPage+"&orderBy="+"CreatedOn" +"&sortDesc="+desc+ "&search=" + searchValue,null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            // response.resultObj.data?.map((item,index)=>{
            //     item.key=index;
            // });
            setData(response?.resultObj?.data);
            setTotal(response?.resultObj?.getCount);
        }else{
            setData([]);
          //   setData( [
          //     {
          //       "rowNum": null,
          //       "companyName": null,
          //       "companyLogo": null,
          //       "address": null,
          //       "salary": null,
          //       "telephone": null,
          //       "fullTime": false,
          //       "partTime": false,
          //       "contract": false,
          //       "hourlyWork": false,
          //       "description": null,
          //       "jobLogo": null,
          //       "applyEmail": null,
          //       "applicationCount": null,
          //       "applyClicks": null,
          //       "createdOn": "0001-01-01T00:00:00",
          //       "spend": 0,
          //       "cpa": 0,
          //       "jobUrl": null,
          //       "statusId": 0,
          //       "appStatus": null,
          //       "daysSincePosted": null,
          //       "jobScreeningQuestions": null,
          //       "spendPerJobsDetails": null,
          //       "isSelfPosted": false,
          //       "createdVia": null,
          //       "jobLocation": null,
          //       "id": 1467195989,
          //       "jobId": 0,
          //       "buyerId": 0,
          //       "supplierId": null,
          //       "logoURL": null,
          //       "applicationId": null,
          //       "cvId": null,
          //       "remoteJobId": null,
          //       "channelid": null,
          //       "boostStreamKey": null,
          //       "supplierName": null,
          //       "userFirstName": null,
          //       "userLastName": null,
          //       "buyerName": null,
          //       "detailsUrl": null,
          //       "active": true,
          //       "posted": "2026-02-27T01:40:12.683",
          //       "priority": 1,
          //       "title": "Night Care Assistant",
          //       "occupation": null,
          //       "reference": "96425",
          //       "place": "Wells",
          //       "county": "",
          //       "city": null,
          //       "state": null,
          //       "country": "United Kingdom",
          //       "countryCode": "GB",
          //       "postcode": "BA5 1WE",
          //       "block": null,
          //       "override": null,
          //       "cost": 0,
          //       "interview": 0,
          //       "hired": 0,
          //       "costInterview": 0,
          //       "costHired": 0,
          //       "cpi": 0,
          //       "cph": 0,
          //       "totalApps": null,
          //       "qualityApps": null,
          //       "offer": null,
          //       "limitUnlimited": null,
          //       "limitTotal": null,
          //       "limitType": null,
          //       "limitUsed": null,
          //       "productKey": null,
          //       "productText": null,
          //       "postingDurationDays": null,
          //       "price_agreement": null,
          //       "priceCurrencySymbol": null,
          //       "productLogo": null,
          //       "productHeader": null,
          //       "buyerPriceCurrency": null,
          //       "priceCurrency": {
          //         "symbol": null,
          //         "name": null,
          //         "short_name": null,
          //         "fractiondigits": null
          //       },
          //       "boosted": null,
          //       "maxApps": null
          //     },
          //     {
          //       "rowNum": null,
          //       "companyName": null,
          //       "companyLogo": null,
          //       "address": null,
          //       "salary": null,
          //       "telephone": null,
          //       "fullTime": false,
          //       "partTime": false,
          //       "contract": false,
          //       "hourlyWork": false,
          //       "description": null,
          //       "jobLogo": null,
          //       "applyEmail": null,
          //       "applicationCount": null,
          //       "applyClicks": null,
          //       "createdOn": "0001-01-01T00:00:00",
          //       "spend": 0,
          //       "cpa": 0,
          //       "jobUrl": null,
          //       "statusId": 0,
          //       "appStatus": null,
          //       "daysSincePosted": null,
          //       "jobScreeningQuestions": null,
          //       "spendPerJobsDetails": null,
          //       "isSelfPosted": false,
          //       "createdVia": null,
          //       "jobLocation": null,
          //       "id": 1467195990,
          //       "jobId": 0,
          //       "buyerId": 0,
          //       "supplierId": null,
          //       "logoURL": null,
          //       "applicationId": null,
          //       "cvId": null,
          //       "remoteJobId": null,
          //       "channelid": null,
          //       "boostStreamKey": null,
          //       "supplierName": null,
          //       "userFirstName": null,
          //       "userLastName": null,
          //       "buyerName": null,
          //       "detailsUrl": null,
          //       "active": true,
          //       "posted": "2026-02-27T01:40:12.683",
          //       "priority": 1,
          //       "title": "Care Assistant - Care Home",
          //       "occupation": null,
          //       "reference": "96426",
          //       "place": "Cirencester",
          //       "county": "",
          //       "city": null,
          //       "state": null,
          //       "country": "United Kingdom",
          //       "countryCode": "GB",
          //       "postcode": "GL7 5DT",
          //       "block": null,
          //       "override": null,
          //       "cost": 0,
          //       "interview": 0,
          //       "hired": 0,
          //       "costInterview": 0,
          //       "costHired": 0,
          //       "cpi": 0,
          //       "cph": 0,
          //       "totalApps": null,
          //       "qualityApps": null,
          //       "offer": null,
          //       "limitUnlimited": null,
          //       "limitTotal": null,
          //       "limitType": null,
          //       "limitUsed": null,
          //       "productKey": null,
          //       "productText": null,
          //       "postingDurationDays": null,
          //       "price_agreement": null,
          //       "priceCurrencySymbol": null,
          //       "productLogo": null,
          //       "productHeader": null,
          //       "buyerPriceCurrency": null,
          //       "priceCurrency": {
          //         "symbol": null,
          //         "name": null,
          //         "short_name": null,
          //         "fractiondigits": null
          //       },
          //       "boosted": null,
          //       "maxApps": null
          //     },{
          //       "rowNum": null,
          //       "companyName": null,
          //       "companyLogo": null,
          //       "address": null,
          //       "salary": null,
          //       "telephone": null,
          //       "fullTime": false,
          //       "partTime": false,
          //       "contract": false,
          //       "hourlyWork": false,
          //       "description": null,
          //       "jobLogo": null,
          //       "applyEmail": null,
          //       "applicationCount": null,
          //       "applyClicks": null,
          //       "createdOn": "0001-01-01T00:00:00",
          //       "spend": 0,
          //       "cpa": 0,
          //       "jobUrl": null,
          //       "statusId": 0,
          //       "appStatus": null,
          //       "daysSincePosted": null,
          //       "jobScreeningQuestions": null,
          //       "spendPerJobsDetails": null,
          //       "isSelfPosted": false,
          //       "createdVia": null,
          //       "jobLocation": null,
          //       "id": 1467006684,
          //       "jobId": 0,
          //       "buyerId": 0,
          //       "supplierId": null,
          //       "logoURL": null,
          //       "applicationId": null,
          //       "cvId": null,
          //       "remoteJobId": null,
          //       "channelid": null,
          //       "boostStreamKey": null,
          //       "supplierName": null,
          //       "userFirstName": null,
          //       "userLastName": null,
          //       "buyerName": null,
          //       "detailsUrl": null,
          //       "active": true,
          //       "posted": "2026-02-26T09:45:59.19",
          //       "priority": 1,
          //       "title": "Activities Coordinator - Care Home",
          //       "occupation": null,
          //       "reference": "96353",
          //       "place": "Shrewsbury",
          //       "county": "",
          //       "city": null,
          //       "state": null,
          //       "country": "United Kingdom",
          //       "countryCode": "GB",
          //       "postcode": "SY3 8PP",
          //       "block": null,
          //       "override": null,
          //       "cost": 0,
          //       "interview": 0,
          //       "hired": 0,
          //       "costInterview": 0,
          //       "costHired": 0,
          //       "cpi": 0,
          //       "cph": 0,
          //       "totalApps": null,
          //       "qualityApps": null,
          //       "offer": null,
          //       "limitUnlimited": null,
          //       "limitTotal": null,
          //       "limitType": null,
          //       "limitUsed": null,
          //       "productKey": null,
          //       "productText": null,
          //       "postingDurationDays": null,
          //       "price_agreement": null,
          //       "priceCurrencySymbol": null,
          //       "productLogo": null,
          //       "productHeader": null,
          //       "buyerPriceCurrency": null,
          //       "priceCurrency": {
          //         "symbol": null,
          //         "name": null,
          //         "short_name": null,
          //         "fractiondigits": null
          //       },
          //       "boosted": null,
          //       "maxApps": null
          //     }
          //   ]
          // )
            //message.error(response?.resultObj?.message);
        }
        setLoading(false);
    };

    //Get Job URl
    const getJobURL = async(occupationId,jobId)=>{
      let occupationIdValue=occupationId?occupationId:"";
      let jobIdValue=jobId?jobId:"";
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialConfigureJobURL+"buyerId="+buyerId+"&occupationId="+occupationIdValue+"&jobId="+jobIdValue);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
          if(response?.resultObj?.data){
            //const urlJob = new URL(response?.resultObj?.data);
            //const extractedURL = `${urlJob?.protocol}//${urlJob?.host}`;
            setJobUrl(response?.resultObj?.data);
            setCareerSiteDomain(response?.resultObj?.careerSiteDomain||null);
          }else{
            setJobUrl('');
            setCareerSiteDomain(null);
          }
        }else{
            setJobUrl('');
            setCareerSiteDomain(null);
        }
    };
    const getOccupations = async() =>{
        setLoading(true);
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialOccupations+buyerId+"&limit=25&pageNo=1&orderBy=OccupationId&sortDesc=false",null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            response.resultObj.data?.map((item,index)=>{
                item.key=index;
                item.value = item.occupationId.toString();
                item.label = item.occupation;
                item.disabled = !!(response.resultObj.defaultExist && item.occupationId===0);
            });
            setOccupations(response?.resultObj?.data);
        }else{
            setData([]);
            message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
        }
        setLoading(false);
    };

    const getJobs = async() =>{
      setLoading(true);
      const response = await APIUtils.apiCall('GET',WebLinks.GetSocialJobs+buyerId+"&limit=25&pageNo=1&orderBy=OccupationId&sortDesc=false",null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          //Added unique key to fix all inner tables opening together
          response.resultObj.data?.map((item,index)=>{
              item.value = item.id;
              item.label = item.job;
          });
          setJobs(response?.resultObj?.data);
      }else{
          setJobs([]);
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };
    const loadSelectableItems = async (type) => {
      let url = '';
      if (type === 'image') {
        url = `${WebLinks.GetSelectableSocialMediaImages}?buyerId=${buyerId}&limit=20`;
      } else if (type === 'video') {
        url = `${WebLinks.GetSelectableSocialMediaVideos}?buyerId=${buyerId}&limit=20`;
      } else if (type === 'text') {
        url = `${WebLinks.GetSelectableSocialMediaTexts}?buyerId=${buyerId}&limit=20`;
      }
      if (!url) {
        return;
      }
      const response = await APIUtils.apiCall('GET', url, null, true, false);
      if (!response.isCatch && response.resultObj.statusCode === "2000") {
        const items = response?.resultObj?.data || [];
        if (type === 'image') {
          setSelectImageItems(items);
        } else if (type === 'video') {
          setSelectVideoItems(items);
        } else if (type === 'text') {
          setSelectTextItems(items);
        }
        setLoadingAsset(false);
      } else {
        setLoadingAsset(false);
        message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
    };

  const openSelectModal = async (type) => {
    document.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    setLoadingAsset(true);
    setSelectModalType(type);
    setSelectModalVisible(true);
    setSelectedCarouselIndex(0);
    await loadSelectableItems(type);
  };
    const handleSelectModalCancel = () => {
      setSelectModalVisible(false);
      setSelectModalType('');
    };

    const handleSelectableItemClick = (item) => {
      if (selectModalType === 'image') {
        const url = item.socialPostImageURL;
        if (url) {
          setSelectedImage(url);
          setImageurl('');
          form.setFieldsValue({
            promoImage: [],
          });
        }
      } else if (selectModalType === 'video') {
        const url = item.socialPostVideoURL;
        if (url) {
          setSelectedVideo(url);
          setVideourl('');
        }
        form.setFieldsValue({
          promoVideo: [],
        });
      } else if (selectModalType === 'text') {
        const text = item.text || item.socialPostText || item.value || item.title || item.description;
        if (text) {
          form.setFieldsValue({ promoText: text });
          setSelectedText(text);
        }
      }
      handleSelectModalCancel();
    };

    const renderSelectionModal = () => {
      const items = selectModalType === 'image'
        ? selectImageItems
        : selectModalType === 'video'
          ? selectVideoItems
          : selectModalType === 'text'
            ? selectTextItems
            : [];
      const title = selectModalType === 'image'
        ? 'Select Promo Image'
        : selectModalType === 'video'
          ? 'Select Promo Video'
          : selectModalType === 'text'
            ? 'Select Promo Text'
            : 'Select Item';

      const emptyDescription = selectModalType === 'text'
        ? 'You do not have any previously used text. Please add or type new promo text.'
        : selectModalType === 'video'
          ? 'You do not have any previously used videos. Please upload a video.'
          : 'You do not have any previously used images. Please upload an image.';

      return (
        <Modal
          title={title}
          open={selectModalVisible}
          onCancel={handleSelectModalCancel}
          footer={null}
          width={650}
          zIndex={2000}
          destroyOnHidden={true}
          className="custom-ant-modal"
        >
          <div style={{ minHeight: 300, position: "relative" }}>
            {loadingAsset && (
              <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-[9999]">
                <Spin/>
              </div>
            )}
            {!loadingAsset && (
              items.length > 0 ? (
                selectModalType === "text" ? (
                  <div className="flex flex-col h-full min-h-[320px]">
                    <div className="flex-1 space-y-3 max-h-[600px] overflow-auto pr-1">
                      {items.map((item, index) => {
                        const textValue = item.socialPostText;

                        return (
                          <Card
                            key={index}
                            hoverable
                            onClick={() => setSelectedCarouselIndex(index)}
                            className={`border border-gray-200 cursor-pointer transition-all duration-200 hover:bg-blue-50 hover:border-blue-300 ${selectedCarouselIndex === index
                                ? '!border-blue-500 bg-blue-50 shadow-md'
                                : ''
                              }`}
                          >
                            <Paragraph ellipsis={{ rows: 4 }} className="mb-0">
                              {textValue}
                            </Paragraph>
                          </Card>
                        );
                      })}
                    </div>

                    <div className="flex justify-end gap-2 mt-auto pt-4">
                      <Button onClick={handleSelectModalCancel}>
                        Cancel
                      </Button>

                      <Button
                        type="primary"
                        style={{ textTransform: 'none' }}
                        onClick={() =>
                          handleSelectableItemClick(
                            items[selectedCarouselIndex]
                          )
                        }
                      >
                        Select Text
                      </Button>
                    </div>
                  </div>
                ) : (
                    <div className="flex flex-col h-full min-h-[320px]">
                      <div className="flex-1 flex items-center">
                        <Carousel
                          key={items.length}
                          centerMode
                          centerPadding="40px"
                          slidesToShow={1}
                          arrows
                          afterChange={(current) => setSelectedCarouselIndex(current)}
                          className="bg-gray-400 rounded w-full"
                        >
                          {items.map((item, index) => {
                            const imageUrlCarousel = item.socialPostImageURL;
                            const videoUrlCarousel = item.socialPostVideoURL;
                            return (
                              <div
                                key={index}
                                className="flex justify-center py-4 min-h-[235px]"
                              >
                                <div className="flex justify-center min-h-[235px] w-full">
                                  {selectModalType === "image" && imageUrlCarousel ? (
                                    <Image
                                      preview={false}
                                      src={imageUrlCarousel}
                                      width={320}
                                    />
                                  ) : selectModalType === "video" && videoUrlCarousel ? (
                                    <video
                                      playsInline
                                      controls
                                      style={{ maxHeight: 360 }}
                                    >
                                      <source src={videoUrlCarousel} />
                                    </video>
                                  ) : (
                                    <div className="h-[180px]" />
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>
                      <div className="flex justify-end gap-2 w-full mt-4">
                        <Button onClick={handleSelectModalCancel}>
                          Cancel
                        </Button>
                        <Button
                          type="primary"
                          style={{ textTransform: 'none' }}
                          onClick={() =>
                            handleSelectableItemClick(items[selectedCarouselIndex])
                          }
                        >
                          {selectModalType === "image"
                            ? "Select Existing Image"
                            : "Select Video"}
                        </Button>
                      </div>
                    </div>
                )
              ) : (
                <Empty description={emptyDescription} />
              )
            )}
          </div>
        </Modal>
      );
    };
    const handleCancel = () => {
      form.resetFields();
      setImageurl('');
      setSelectedText('');
      setSelectModalVisible(false);
      setSelectModalType('');
      setNewModalOpen(false);
      setJobId(null);
      if(updateRecord){
        setUpdateRecord(null);
      }
      setFinalURL('');
      setUrlTypeValue('CareersSiteJobURL');
      setSelectImageItems([]);
      setSelectVideoItems([]);
      setSelectTextItems([]);
      setUpdateImage(null);
      setUpdateVideo(null);
      setSelectedImage(null);
      setSelectedVideo(null);
      setLoadingAsset(true);
    };
    const onFinish = async (values) => {
      if (imageurl !== '' || selectedImage || updateImage){
        if(values?.promoVideo && values?.promoVideo[0]?.originFileObj){
          if(values?.promoVideo[0]?.originFileObj.type!=="video/mp4"){
            message.error('You can only upload MP4 files!');
          }else{
            saveConfig(values);
          }
        }else{
          saveConfig(values);
        }
      }else{
        message.error("Please select or upload an image.")
      }
    };
  const saveSelectedMediaUrls = async (id) => {
    try {
      const payload = {
        imageUrlExists: !!selectedImage,
        imageUrl: selectedImage || "",
        videoUrlExists: !!selectedVideo,
        videoUrl: selectedVideo || ""
      };
      payload.id = id || updateRecord?.id;
      const response = await APIUtils.apiCall(
        'PUT',
        WebLinks.UpdatePromoImageVideoURL,
        JSON.stringify(payload),
        true,
        false
      );
      if (
        response.isCatch ||
        response?.resultObj?.statusCode !== "2000"
      ) {
        message.error(
          response?.resultObj?.message ||
          "Failed to save selected media"
        );
        return false;
      }
      return true;
    } catch (error) {
      message.error("Failed to save selected media");
      return false;
    }
  };
    const saveConfig=async (values)=>{
      // if((values?.occupation?.toString() && values.job) ||(!values?.occupation?.toString() && !values.job)){
      //   form.setFieldsValue({
      //     occupation: null,
      //     job:null,
      //   })
      //   message.error("Please select either an occupation or a job.")
      // }
      // else{
      const formData = new FormData();
      // if((values?.promoImage && values?.promoImage[0]?.originFileObj)||(imageurl!=='' && imageurl!==updateImage)){
      //   formData.append('Image', values.promoImage[0].originFileObj ? values.promoImage[0].originFileObj : imageurl);
      // }
      if (imageurl&& imageurl!==updateImage) {
        formData.append('Image', imageurl);
      }
      // if(values?.promoVideo && values?.promoVideo[0]?.originFileObj){
      //   formData.append('Video',  values.promoVideo[0].originFileObj);
      // }
      if (videourl && videourl !== updateVideo) {
        formData.append('Video', videourl);
      }
      if(updateRecord){
        formData.append('SocialConfigure.Id', updateRecord.id);
      }
      formData.append('SocialConfigure.JobId', jobId);
      formData.append('SocialConfigure.BuyerId', buyerId);
      if(values.occupation){
      formData.append('SocialConfigure.OccupationId', values.occupation);
      }
      if(values.location){
      formData.append('SocialConfigure.Location', values.location);
      }
      if(values.job){
      formData.append('SocialConfigure.JobId', values.job);
      }
      if(values.spendperad){
      formData.append('SocialConfigure.SpendPerAd', values.spendperad);
      }
      if(values.promoText){
      formData.append('SocialConfigure.SocialPostText', values.promoText);
      }
      const socialPostURLType = isSelfServiceUser
        ? careerSiteDomain == null ? "ApplyGatewayJobURL" : "HICareersSiteJobURL"
        : values.urlTypes;
      if(socialPostURLType){
      formData.append('SocialConfigure.SocialPostURLType', socialPostURLType);
      }
      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCode){
        formData.append('SocialConfigure.SocialPostURLParams', values.urltrackingCode);
      }
      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCodeReplace){
        formData.append('SocialConfigure.socialPostURLParamsReplace', values.urltrackingCodeReplace);
      }
      if(urlTypeValue==="LandingPageURL" && values?.landingPageUrl){
        formData.append('SocialConfigure.SocialPostLandingPage', values.landingPageUrl);
      }
      try {
        let url= updateRecord?WebLinks.UpdateSocialMediaConfig:WebLinks.AddSocialMediaConfig;
          const response = await fetch(url, {
            method: updateRecord?'PUT':'POST',
            headers: {
              Authorization: "Bearer "+Cookies.get(constants.COOKIE_TOKEN)
            },
            body: formData,
          });
          const responseData = await response.json();
          if (response.ok) {
            if (updateRecord && (selectedImage || selectedVideo)) {
              const mediaSaved = await saveSelectedMediaUrls(updateRecord.id);
              if (!mediaSaved) {
                return;
              }
            }
            if (!updateRecord && (selectedImage || selectedVideo)) {
              const insertedId = responseData?.socialPostInsertedId
              if (insertedId) {
                const mediaSaved = await saveSelectedMediaUrls(insertedId);
                if (!mediaSaved) {
                  return;
                }
              }
            }
            message.success(responseData?.message || "Inserted record successfully");
            handleCancel();
            getData(searchedValue,currentPage,pageSize);
          } else {
              message.error(responseData?.message || constants.ERROR_MESSAGE);
          }
        } catch (error) {
          console.error('Error uploading image:', error);
      } 
      // } 
    }
    const loadOccupations =async()=>{
      if (!occupations.length > 0) {
        await getOccupations();
      }
    };

  const renderSelectedImagePreview = () => {
    let previewUrl = selectedImage || updateImage;
    const imagePreview = previewUrl
      ? [{
        uid: '-1',
        name: previewUrl?.split('/')?.pop() || 'Image',
        status: 'done',
        url: previewUrl,
        thumbUrl: previewUrl,
      }]
      : [];

    if (!imagePreview.length) {
      return null;
    }
    return (
      <div>
        <Upload
          className="custom-upload-wrap"
          listType="picture"
          fileList={imagePreview}
          maxCount={1}
          showUploadList={{
            showPreviewIcon: true,
            showRemoveIcon: true,
          }}
          onRemove={() => {
            setSelectedImage(null);
            setUpdateImage(null);
          }}
        />
      </div>
    );
  };
  const renderSelectedVideoPreview = () => {
    const previewUrl =
      selectedVideo || updateVideo;
    const videoPreview = previewUrl
      ? [{
        uid: '-1',
        name: previewUrl?.split('/')?.pop() || 'Video',
        status: 'done',
        url: previewUrl,
      }]
      : [];

    if (!videoPreview.length) {
      return null;
    }
    return (
      <div>
        <Upload
          className="custom-upload-wrap"
          listType="picture"
          maxCount={1}
          fileList={videoPreview}
          showUploadList={{
            showPreviewIcon: false,
            showRemoveIcon: true,
          }}
          onRemove={() => {
            setSelectedVideo(null);
            setUpdateVideo(null);
          }}
        />
      </div>
    );
  };
  const renderUpdateImageFields = () => {
    return (
      <div className="mb-5">
        <div className="flex flex-wrap items-start gap-3">
          <div>
            <Button type="default" onClick={() => openSelectModal('image')}>
              Select Existing Image
            </Button>
            {renderSelectedImagePreview()}
          </div>
          <div>
            <Form.Item
              name="promoImage"
              className="!mb-0"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList || [];
              }}
            >
              <Upload
                name="logo"
                className="custom-upload-wrap"
                listType="picture"
                accept=".png,.jpg,.jpeg"
                beforeUpload={() => false}
                onChange={(e) => onUploadChange(e)}
                maxCount={1}
                onRemove={() => {
                  setImageurl('');
                }}
              >
                <Button icon={<UploadOutlined />}>
                  Upload New Image
                </Button>
              </Upload>
            </Form.Item>
            <div className="mt-2">
              <i>(Requirements: JPG or PNG. Min Width 600px / Ratio 1:1 (Square) or 4:5)              </i>
            </div>
            <div className="mt-2">
              <i>Recommended: Have the text 'We Are Hiring' in the image</i>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderUpdateVideoFields = () => {
    return(
      <div className="mb-5">
        <div className="flex flex-wrap items-start gap-3">
          <div>
            <Button type='default' onClick={() => openSelectModal('video')}>
              Select Video
            </Button>
            {renderSelectedVideoPreview()}
          </div>
          <div>
            <Form.Item
              name="promoVideo"
              className="!mb-0"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList || [];
              }}
            >
              <Upload
                className="custom-upload-wrap"
                name="videoPromo"
                listType="picture"
                accept="video/mp4"
                beforeUpload={()=>false}
                onChange={onVideoUploadChange}
                maxCount={1}
                onRemove={() => {
                  setVideourl('');
                }}
              >
                <Button icon={<UploadOutlined />}>
                  Click to add Promo Video
                </Button>
              </Upload>
            </Form.Item>
            <div className="mt-2">
              <i>(MP4 file only)</i>
            </div>
          </div>
        </div>
      </div>
    );
  };
    const handleTableChange = (pagination, filters, sorter) => {
      setPagination(pagination);
      if(sorter?.field!==undefined){
        setSorter(sorter);
      }
    };
    const handlePlay = (url) => {
      setVideoUrl(url);
      setVisibleVideo(true);
    };
  
    const handleCancelVideo = () => {
      setVideoUrl('');
      setVisibleVideo(false);
    }
    const [imageurl,setImageurl]=useState('');
    const [videourl, setVideourl] = useState('');
    const onUploadChange=(e)=>{
      const imageUrl = e.fileList[0].originFileObj;
      setImageurl(imageUrl);
      setSelectedImage(null);
      setUpdateImage(null);
    }
    const onVideoUploadChange = (e) => {
      const videoFile = e.fileList?.[0]?.originFileObj;
      if (videoFile) {
        setVideourl(videoFile);
        setSelectedVideo(null);
        setUpdateVideo(null);
      } else {
        setVideourl('');
      }
    };
    const handleImageLoad = (e) => {
      const { naturalWidth, naturalHeight } = e.target; // Get image dimensions
      const aspectRatio = naturalWidth / naturalHeight;
       if ( (aspectRatio !== 1 && aspectRatio !== 4 / 5)) {
          message.error('Image requirements not matching.');
          setImageurl('');
      }
    };
    const redirectToJobURL = (codeReplace, trackingCode, loadCall="f", baseUrl) => {
      const normalizeTrackingCode = (trackingCode) =>
        trackingCode?.trim()?.replace(/^[?&]+/, '') || '';
      const replaceTrackingCode = normalizeTrackingCode(codeReplace?codeReplace: form.getFieldValue("urltrackingCodeReplace"));
      const newTrackingCode = normalizeTrackingCode(trackingCode?trackingCode: form.getFieldValue("urltrackingCode"));
      let finalJobUrl = baseUrl || jobURl || "";

      if (!finalJobUrl) {
        setFinalURL('');
        if(loadCall!=="t"){
        message.error("No Career site URL found.");
        }
        return;
      }

      if (newTrackingCode) {
        if (replaceTrackingCode && replaceTrackingCode.length > 0) {
          const escapedTrackingCode = replaceTrackingCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const exactTrackingCodePattern = new RegExp(`([?&])${escapedTrackingCode}(?=&|$)`);
          const trackingParameterName = replaceTrackingCode.split('=')[0];
          const escapedParameterName = trackingParameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const trackingParameterPattern = new RegExp(`([?&])${escapedParameterName}=[^&]*`);
          const replacement = (match, separator) => `${separator}${newTrackingCode}`;

          finalJobUrl = exactTrackingCodePattern.test(finalJobUrl)
            ? finalJobUrl.replace(exactTrackingCodePattern, replacement)
            : finalJobUrl.replace(trackingParameterPattern, replacement);
        } else {
          finalJobUrl = `${finalJobUrl}${finalJobUrl.includes("?") ? "&" : "?"}${newTrackingCode}`;
        }

        setJobUrlParam(newTrackingCode);
      } else if (replaceTrackingCode) {
        const parameterName = replaceTrackingCode.split('=')[0];
        const escapedParameterName = parameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        finalJobUrl = finalJobUrl.replace(new RegExp(`[?&]${escapedParameterName}=[^&]*`), '');
        finalJobUrl = finalJobUrl.replace(/\?&/g, '?').replace(/&&+/g, '&').replace(/[?&]$/, '');
        setJobUrlParam('');
      }
      setFinalURL(finalJobUrl);
      if(loadCall!=="t"){
        window.open(finalJobUrl, '_blank');
      }
    }
    const subFieldsRender =(label, itemValue, prefix="") =>{
      let ClassNames='font-semibold';
      if(label!=="Budget"){
        ClassNames+= itemValue && parseInt(itemValue)>0?' text-green-500':' text-red-500';{/* Red color class="text-red-500" */}
      }
      return(
        <div>
          <label className='font-bold'>{label}: </label>
          <span className={ClassNames}>{itemValue?prefix+itemValue:" -"}</span>
        </div>
      )	
    };
    const renderJobAdCards = (item,index) =>{
      return(
        <Card
          className='w-full text-xs h-full flex flex-col gap-1'
          styles={{
            body: {
              padding: 10,
            },
          }}
        >        <div className='flex justify-between items-center'>
        </div>
          <div className="space-y-2 min-h-[110px]">
            <div className="leading-5 line-clamp-2 overflow-hidden">
              <label className='font-bold'>Job Title: </label>
              <span className='font-semibold'>{item?.title}</span>
            </div>
            <div className="min-h-[20px]">
              {item?.place ? (
                <>
                  <label className='font-bold'>Location: </label>
                  <span className='font-semibold'>{item?.place}</span>
                </>
              ) : null}
            </div>
            {item?.published!==1 ? (
              <div className="min-h-[20px]">
                <span className='font-semibold'>Publishing</span>
              </div>
            ) : 
            <div className="min-h-[36px] flex items-center">
              {item.publishAd === 1 ? (
                <>
                  <label className='font-bold mr-2'>Publish Ad: </label>
                  {GenerateCurrencyArray(item?.spendPerAd, item)}
                </>
              ) : null}
            </div>}
          </div>

          <Card
            className='w-full mt-2 flex-1'
            hoverable
            bodyStyle={{
              padding: 10,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={() => {
              setJobId(item.jobId);
              if (item?.socialPostText) {
                handleUpdate(item.id);
              } else {
                setNewModalOpen(true);
              }
            }}
          >
          <Space size={8}>
            <Avatar
              src={<img style={{
                width: '30px', 
                height: '30px', 
                objectFit: 'contain', 
              }} src={item?.logoURL||null} alt="avatar" />}
              size="large" className='border border-gray-300'
            />
            <Space direction='vertical' size={0}>
              <div className='font-bold text-sm'>{item?.companyName}</div>
              {item?.socialPostText?
              <div className='text-xs'>Sponsored</div>:null}
            </Space>
          </Space>
            <div className='mt-2'>
              {item?.socialPostText ? (
                <Paragraph
                  ellipsis={{ rows: 4 }}
                  className='text-xs !mb-0'
                >
                  {item.socialPostText}
                </Paragraph>
              ) : (
                <div className='h-[48px] flex items-start'>
                  <Button
                    type='link'
                    onClick={(e) => {
                      e.preventDefault();
                      setJobId(item.jobId);
                      setNewModalOpen(true);
                    }}
                  >
                    Configure Ad
                  </Button>
                </div>
              )}
            </div>
          {item?.socialPostText?
          <div className='text-right'>
            <Button type='link' 
              onClick={(e) => {
                e.stopPropagation();
                setJobId(item.jobId);
                handleUpdate(item.id);
              }}>
                Edit Ad</Button>
            <CheckCircleFilled className='text-green-500' />
          </div>:null}
            <div className='mt-1 bg-gray-200 flex items-center justify-center h-[155px] overflow-hidden'>
              {item?.socialPostImageURL ? (
                <Image
                  preview={false}
                  src={item?.socialPostImageURL}
                  className='!w-[150px] !h-[150px] object-cover'
                />
              ) :
            <Tooltip title="Configure Ad">
              <Image
                width={150}
                preview={false}
                className='!w-[150px] !h-[150px] object-cover'
                onClick={(e) => {
                  e.preventDefault();
                  setJobId(item.jobId);
                  setNewModalOpen(true);
                }}
                src={SocialConfigureDefault}
              />
            </Tooltip>
            }
          </div>
          <div className='flex justify-between items-center mt-2'>
            <div>
              <div className='uppercase font-semibold text-xxs'>
                {item.companyName}
              </div>
              <div className='font-bold text-xxs'>
                {item?.title} in {item?.place}
              </div>
            </div>
            {item?.socialPostLandingPage?
            <Button size='small' className='!text-xs bg-gray-200 m-1' 
            //href={item.landing_page_url}
            onClick={()=>window.open(`${item?.socialPostLandingPage}`,"_blank")}
            >
              Learn More
            </Button>:null}
          </div>
        </Card>
      </Card>
      )
    }

    const createArray = (startNumber) => {
      return Array.from({ length: 10 }, (_, index) => { 
        const valueItem = Number(startNumber) + index * 50;
        let valueLabel = currencyContext.currency;
        return {
          value: valueItem,
          label: valueLabel+" "+valueItem
        };
      });
    };
    const savePublishAdDetail=async(value,record)=>{
      let payload;
      payload={
          id:record.id,
          userId:record.id,
          buyerId:buyerId,
          spendPerAd:value,
          jobId:record.jobId
      }
      let apiURl;
      let urlType;
      if(isSelfService === "true" || isSelfService === true ){
        apiURl=WebLinks.InsetSelfPostPublisAdDetails
        urlType='POST'
      }else{
        apiURl=WebLinks.UpdatePublisAdDetails
        urlType='PUT'
      }
      const response = await APIUtils.apiCall(urlType, apiURl ,JSON.stringify(payload));
      if (!response.isCatch && response.resultObj.statusCode === "2000") {
          message.success(response.resultObj.message)
          // getJobs();
          getData(searchedValue,currentPage,pageSize);
      } else {
          message.error(response.resultObj.message)
      }
    }
  
    const handleCurrencyChange = (newValue,record) => {
      Modal.confirm({
        title: "Publish Ad",
        content: `This will publish your job ad with this budget. Budgets can only be increased not reduced after publishing.`,
        okText: "Publish",
        cancelText: "Cancel",
        okType:"primary",
        onOk() {
          savePublishAdDetail(newValue,record)
        },
      });
    };
    const GenerateCurrencyArray = ( startValue,record ) => {  
      let tempArray=[];
      tempArray= createArray(startValue||100)
      return (
         <Select className='w-30' options={tempArray} value={startValue||[]} onChange={(e,item)=>handleCurrencyChange(e,record)} placeholder={"Budget"}/>
      )
    }
    const redirectToLandingURL=()=>{
      let getLandingURL= form.getFieldValue("landingPageUrl");
        if(getLandingURL){
          window.open(getLandingURL, '_blank');
        }else{
          message.error("No Landing page URL found.")
        }
    }
    const handleSizeChange = (page,newSize) => {
      setPageSize(newSize);
      setCurrentPage(page);
      getData(searchedValue,page,newSize);
      };

    useEffect(()=>{
        generateOptions();
        getJobs();
        getData("",currentPage,pageSize);
        getJobURL();
        // getSiteUrls();
    },[]);
  const renderImageControls = () => (
    <div className="flex flex-wrap items-start gap-3">
      <div>
        <Button onClick={() => openSelectModal('image')}>
          Select Existing Image
        </Button>
        {renderSelectedImagePreview()}
      </div>
      <div>
        <Form.Item
          name="promoImage"
          className="!mb-0"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e?.fileList || [];
          }}
          // rules={[{ required: true, message: "Promo image required." }]}
        >
          <Upload
            className="custom-upload-wrap"
            name="logo"
            listType="picture"
            accept=".png,.jpg,.jpeg"
            beforeUpload={() => false}
            onChange={(e) => onUploadChange(e)}
            maxCount={1}
            onRemove={() => {
              setImageurl('');
            }}
          >
            <Button icon={<UploadOutlined />}>
              Upload New Image
            </Button>
          </Upload>
        </Form.Item>
        <div className="mt-2">
              <i>(Requirements: JPG or PNG. Min Width 600px / Ratio 1:1 (Square) or 4:5)              </i>
            </div>
            <div className="mt-2">
              <i>Recommended: Have the text 'We Are Hiring' in the image</i>
            </div>
      </div>
    </div>
  );

  const renderVideoControls = () => (
    <div className="flex flex-wrap items-start gap-3">
      <div>
        <Button onClick={() => openSelectModal('video')}>
          Select Video
        </Button>
        {renderSelectedVideoPreview()}
      </div>
      <div>
        <Form.Item
          name="promoVideo"
          className="!mb-0"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e?.fileList || [];
          }}
        >
          <Upload
            className="custom-upload-wrap"
            name="videoPromo"
            listType="picture"
            accept="video/mp4"
            beforeUpload={() => false}
            onChange={onVideoUploadChange}
            maxCount={1}
            onRemove={() => {
              setVideourl('');
            }}
          >
            <Button icon={<UploadOutlined />}>
              Click to add Promo Video
            </Button>
          </Upload>
        </Form.Item>
        <div className="mt-2"><i>(MP4 file only)</i></div>
      </div>
    </div>
  );
  return(
    <div>
        <Spin spinning={Loading}>
            <div className='flex flex-wrap justify-between items-center'>
                <div className='uppercase font-bold text-xl'>{" "}</div>
                <div>
                    <Search
                      placeholder="Search"
                      allowClear
                      onSearch={(e) =>{setSearchedvalue(e);setCurrentPage(1); getData(e,1,pageSize)}}
                      //onChange={(e) => { searchJob(e.target.value); setSearchedValue(e.target.value) }}
                      enterButton
                      className="w-full md:w-60"
                    />
                    {/* <Button type="primary" style={{ marginRight: '10px' }} onClick={async () => {
                        loadOccupations();
                        setNewModalOpen(true);
                        form.setFieldsValue({
                          urlTypes:"CareersSiteJobURL"
                    })
                    }}>
                        Add New
                    </Button> */}
                    {/* Add your logic to handle the "Add New" button */}
                </div>
            </div>
            <Divider className='my-3' />
            {/* <Table scroll={{ x: '1000' }} sortDirections={['descend', 'ascend', 'descend']} columns={columns} dataSource={data} pagination={pagination} onChange={handleTableChange}/> */}
            {data.length>0?(
            <div className='mt-3'>
              <Row gutter={[16, 16]} className="w-full">
              {data?.map((item,index)=>{
                return(
                  <Col xs={24} md={12} lg={8} xxl={6} key={index} className="flex w-full">
                    {renderJobAdCards(item,index)}
                  </Col>
                );
              })}
              </Row>
              <div className='mt-3 grid place-content-end'>
                <Pagination 
                  showSizeChanger
                  pageSizeOptions={["40","80","120","160"]}
                  pageSize={pageSize}
                  //onShowSizeChange={handleSizeChange}
                  current={currentPage} 
                  total={total} 
                  onChange={(e,item)=>{handleSizeChange(e,item)}}/>
              </div>
            </div>
            ):<Empty/>}
            <Modal
              title={updateRecord?"Edit Configuration":"Add New Configuration"}
              open={NewModalOpen}
              onCancel={handleCancel}
              destroyOnHidden={true}
              okText={<span className="capitalize">Save</span>}
              onOk={() => form.submit()}
              style={{ top: 20 }}
              width={800}
            >
                <Form form={form} name="form_in_modal" layout="vertical" onFinish={onFinish}>
                <div className="ant-form-item-label mt-5 mb-3">
                  <label>
                    Promo Image
                  </label>
                </div>
                  {updateRecord ? renderUpdateImageFields() : (
                    <div className="mb-8">
                      {renderImageControls()}
                    </div>
                  )}
                  <Form.Item hidden>
                    <Image src={imageurl}  onLoad={handleImageLoad}/>
                  </Form.Item>
                  <div className="ant-form-item-label mt-5 mb-3">
                    <label>
                      Promo Video
                    </label>
                  </div>
                  {updateRecord && updateRecord.socialPostVideoURL ? (
                    renderUpdateVideoFields()
                  ) : (
                    <div className="mb-8">
                      {renderVideoControls()}
                    </div>
                  )}
                    <div className='mb-4'>
                      <Button type='default' onClick={() => openSelectModal('text')}>
                        Use Previous Text
                      </Button>
                    </div>              
                    <Form.Item
                        name="promoText"
                        label="Promo Text"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Input.TextArea rows={5}/>
                    </Form.Item>
                    {/* <Form.Item
                        name="spendperad"
                        label="Spend Per Ad"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Select options={countArrayOptions} />
                    </Form.Item> */}
                    {!isSelfServiceUser && <Form.Item
                        name="urlTypes"
                        label="Send clicks to URL type"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "Required field",
                        //     },
                        // ]}
                    >
                      <Select
                        onChange={(value) => {
                          setUrlTypeValue(value);
                          setFinalURL('');
                          form.setFieldsValue({ sendClickstoURL: undefined });
                        }}
                        defaultValue={
                          isSelfService === true || isSelfService === "true"
                            ? careerSiteDomain !== null
                              ? "HICareersSiteJobURL"
                              : "ApplyGatewayJobURL"
                            : "CareersSiteJobURL"
                        }
                        options={urlTypeOptions}
                      />
                    </Form.Item>}
                    {/* {(urlTypeValue === "LandingPageURL" || urlTypeValue === "CareersSiteJobURL") && (
                      <Form.Item
                        name="sendClickstoURL"
                        label="Send Clicks to URL"
                      >
                        <Select
                          placeholder="Select URL"
                          onChange={(value) => redirectToJobURL(undefined, undefined, "t", value || jobURl)}
                          options={siteUrlLinks
                            .filter((siteUrl) =>
                              siteUrl.resultType ===
                              (urlTypeValue === "LandingPageURL" ? "Landing Page" : "Careers Site")
                            )
                            .map((siteUrl) => ({
                              value: siteUrl.value,
                              label: siteUrl.displayText,
                            }))}
                        />
                      </Form.Item>
                    )} */}
                    {!isSelfServiceUser && urlTypeValue === "CareersSiteJobURL" 
                    // || urlTypeValue === "LandingPageURL"
                  ?
                    <>
                    <Form.Item
                        name="urlLabel"
                        label="Example of Your URL"
                      >
                    <label>{finalURL || jobURl || ''}</label>                    </Form.Item>
                    <Space>
                      {/* {updateRecord? */}
                      <Form.Item
                        name="urltrackingCodeReplace"
                        label="Replace this tracking Code"
                      >
                        <Input />
                    </Form.Item>
                    {/* :null} */}
                      <Form.Item
                        name="urltrackingCode"
                        label="Add URL Tracking Codes"
                      >
                        <Input />
                      </Form.Item>
                      <span>
                        <i>(Optional)</i>
                        <Button
                          type='link'
                          className='pr-1'
                          onClick={() => redirectToJobURL()}
                        >
                          Click Here
                        </Button>
                        to test
                      </span>
                    </Space>
                    </>
                    : null}
                    {urlTypeValue === "LandingPageURL" && (
                    <div>
                      <Form.Item
                      className='mb-0'
                      name="landingPageUrl"
                      label="Landing Page - Enter custom URL"
                      rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                          {
                            type: 'url',
                            message: 'Please enter a valid URL (e.g., https://example.com)',
                          }
                      ]}
                      >
                          <Input/>
                      </Form.Item>
                      <span ><i>(Please enter full URL including https://)</i><Button type='link' className='pr-1' onClick={()=>redirectToLandingURL()}>Click Here</Button>to test</span>
                    </div>
                    )}
                </Form>
            </Modal>
            {renderSelectionModal()}
            <Modal
              title="Promo Video"
              open={visibleVideo}
              onCancel={handleCancelVideo}
              footer={null}
              width={800}
            >
              <video
                src={videoUrl}
                controls
                style={{ width: '100%' }}
                autoPlay
              />
            </Modal>
        </Spin>
  </div>
    );
};

export default SocialMediaConfigure;
